import React from "react";
import { Modal } from "react-bootstrap";
import { Helmet } from "react-helmet";
import {cartItem} from "../../../models/cart.model";
import {getStructuredItem} from "../../../helpers/scripts/seoScript";
import {useStoreLocation} from "../../../context/StoreLocation";
import { useIsDesignV2 } from "../../../hooks/useIsDesignV2";

interface ItemRemoveModalProps {
  showModal: boolean;
  loading: boolean;
  handleClose: () => void;
  removeItem: () => void;
  item: cartItem;
  userId: number;
}
const ItemRemoveModal: React.FC<ItemRemoveModalProps> = ({
  showModal,
  handleClose,
  removeItem,
  loading,
  item,
  userId
}) => {
  const {locationInfo} = useStoreLocation()
  const isDesignV2 = useIsDesignV2();
  return (
    <>
      {
          showModal &&
          <Helmet>
            <script>
              {
                `
             document.getElementById("remove_item_button").addEventListener("click", function () {
               gtag("event", "remove_from_cart", {
                 user_id: ${userId || null},
                 currency: "USD",
                 value: ${item?.display_price},
                 items: [
                 ${JSON.stringify(getStructuredItem(item, locationInfo?.selectedStore?.id))}
                 ]
               });
             });             
            `
              }
            </script>
          </Helmet>
      }
      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        className="theme-modal-style app_container_wrap no-padding border-radius-8 no-border"
      >
        <Modal.Header className="pt-0" id="close_button2">
          <button
            type="button"
            className="btn modal-close-button pe-0 blue-icon"
            onClick={handleClose}
          >
            Close
          </button>
        </Modal.Header>
        <Modal.Body className={`text-center ${isDesignV2 ? 'py-4 px-0' : 'py-5'}`}>
          <h6 className={`font-Cls ls-normal mb-sm-4 mb-3 ${isDesignV2 ? 'f-s21 ls-05 clr-dark-grey' : 'f-s22' }`}>Remove Item</h6>
          <p className={`mb-4 ${isDesignV2 ? 'f-s14 f-w4 lh-normal ls-05' : 'f-s14 '}`}>
            Are you sure you want to remove this item {isDesignV2 ? '' : <br/>} from your order?
          </p>
          <div className="text-center">
            <button
              type="button"
              className={`btn btn-large  d-block ${isDesignV2 ? 'w-100 py-2 lh-normal mb-4' : 'mx-auto mb-sm-4 mb-3'}`}
              onClick={removeItem}
              id={"remove_item_button"}
              disabled={loading}
            >
              Remove
            </button>
            <button
              type="button"
              onClick={handleClose}
              className="btn btn-custom f-s16 font-Vcf clr-dark-blue p-0 ls-05"
            >
              No, Keep the Order
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ItemRemoveModal;
